import {
    Box,
    Divider,
    Flex,
    Heading,
    HStack,
    Icon,
    Text,
    Tooltip,
} from '@chakra-ui/react'
import { useRef, useState } from 'react'

import { defaultBorder, thickBoxShadow } from '../chakraTheme'
import {
    CheckBoxChecked,
    CheckBoxUnChecked,
    HeartBreak,
    Idea,
    NoCopy,
} from '../components/Icons/axInstructions'
import { ArrowForward, Info, PreviousArrow } from '../components/Icons/default'
import PrimaryButton from '../components/PrimaryButton'

const NavFooter = ({
    isFirstPage,
    nextBtnRef,
    isNextDisabled,
    handleNext,
    handlePrevious,
}) => {
    return (
        <Flex
            w={'full'}
            py={'6'}
            justifyContent={'space-between'}
            flexDirection={'row-reverse'}
        >
            <Tooltip
                isDisabled={!isNextDisabled}
                hasArrow
                label={
                    <Box fontWeight={'normal'}>
                        <HStack>
                            <Box mr={5}>
                                <Info h={6} w={6} />
                            </Box>
                            <Box marginInlineStart={'0 !important'}>
                                To proceed, please agree to the honour code by
                                checking the box.
                            </Box>
                        </HStack>
                    </Box>
                }
                placement="top-end"
                bg={'ziggurat'}
                color={'codgray'}
                padding={'6'}
                boxShadow={thickBoxShadow}
                border={defaultBorder}
                borderRadius={'none'}
                offset={[-4, 10]}
                sx={{
                    '.chakra-tooltip__arrow': {
                        boxShadow: '8px 2px 0 #333333 !important',
                    },
                }}
            >
                <Flex>
                    <PrimaryButton
                        wrapperProps={{
                            marginLeft: 'auto',
                            _hover: {},
                            onClick: e => {
                                if (isNextDisabled) return e.preventDefault()
                                handleNext()
                            },
                        }}
                        variant={isNextDisabled ? 'disabled' : 'clickable'}
                        rightIcon={
                            <ArrowForward
                                fontSize={'2xl'}
                                color={isNextDisabled ? 'alto2' : 'white'}
                            />
                        }
                        ref={nextBtnRef}
                        colorScheme={'rum'}
                        my={{ base: 4, md: 0 }}
                        w={{ base: 'full', md: 'auto' }}
                        _hover={{}}
                    >
                        Next
                    </PrimaryButton>
                </Flex>
            </Tooltip>
            <Flex
                align="center"
                cursor="pointer"
                onClick={handlePrevious}
                color="emperor"
                display={isFirstPage ? 'none' : 'flex'}
            >
                <PreviousArrow h={6} w={6} />
                <Heading
                    ml={2}
                    fontSize={{ base: 'sm', md: 'md' }}
                    fontWeight="bold"
                >
                    Previous
                </Heading>
            </Flex>
        </Flex>
    )
}

const HonourText = ({ text, icon }) => {
    return (
        <Flex mt={8} flexDirection={'row'}>
            <Icon as={icon} fontSize={'4xl'} color={'scorpion2'} />
            <Text fontWeight={'400'} ml={4} color="codgray">
                {text}
            </Text>
        </Flex>
    )
}

const HonourCodeStep = ({
    isFirstPage,
    isDefaultAgreed,
    handleNext,
    handlePrevious,
    onCheckClicked,
}) => {
    const [isAgreed, setAgreed] = useState(isDefaultAgreed)
    const nextBtnRef = useRef(null)

    return (
        <Flex
            pl={16}
            pr={16}
            pt={'194px'}
            flexDirection="column"
            height={'full'}
        >
            <Heading fontWeight={'extrabold'} fontSize="2xl">
                Kalvium Honour Code
            </Heading>
            <Text mt={2} color="scorpion2">
                Before you start this challenge, we want you to take a take
                pledge - that you will abide by Kalvium Honour Code. Here’s what
                you are promising us.
            </Text>
            <HonourText
                text={
                    'I solemnly swear that I am up to no dishonesty! I promise to be truthful, and honourable and use only my powers of knowledge to complete this challenge.'
                }
                icon={Idea}
            />
            <HonourText
                text={
                    "I solemnly swear that I will not engage in malpractice such as (but not limited to) copying from my peers, using unauthorized resources (we're looking at you, ChatGPT!), or collaborating with others."
                }
                icon={NoCopy}
            />
            <HonourText
                text={
                    'I also solemnly swear that failure to follow the aforementioned two points in the honour code will result in a life sentence of guilt, shame, eternal bad luck, and rejection from the Kalvium program.'
                }
                icon={HeartBreak}
            />
            <Flex
                flexGrow={1}
                mt={12}
                mb={'124px'}
                flexDirection={'row'}
                onClick={() => {
                    setAgreed(!isAgreed)
                    onCheckClicked(!isAgreed)
                }}
                cursor={'pointer'}
                userSelect={'none'}
            >
                <Icon
                    as={isAgreed ? CheckBoxChecked : CheckBoxUnChecked}
                    fontSize={'4xl'}
                />
                <Text
                    ml={5}
                    mt={1}
                    fontWeight={'400'}
                    fontSize={'md'}
                    color={'codgray'}
                    fontStyle={'normal'}
                >
                    I solemnly swear to abide by the Kalvium Honour Code.
                </Text>
            </Flex>
            <Divider borderBottom={'3px solid rgba(69, 69, 69, 0.2);'} />
            <NavFooter
                isFirstPage={isFirstPage}
                nextBtnRef={nextBtnRef}
                isNextDisabled={!isAgreed}
                handleNext={handleNext}
                handlePrevious={handlePrevious}
            />
        </Flex>
    )
}

export default HonourCodeStep
